import { toast } from 'react-toastify';
import { SET_ERRORS } from '../helpers/constants';

export const setErrors = (message: string) => {
    toast.error(message, { position: toast.POSITION.TOP_CENTER });

    return { type: SET_ERRORS, payload: message };
};
